import DeterminateProgress from "../../components/input/new/determinateProgress";
import React, { useState } from "react";
import "./setGoals.css";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import goalImg from "./assets/goalImg.png"; // For demonstration
import { useNavigate, useLocation } from "react-router-dom";

export default function SetGoals() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;

  const [selectedGoals, setSelectedGoals] = useState([]);

  const handleToggle = (id) => {
    if (selectedGoals.includes(id)) {
      // If already selected, unselect it
      setSelectedGoals(selectedGoals.filter((goalId) => goalId !== id));
    } else {
      // Otherwise, add it
      setSelectedGoals([...selectedGoals, id]);
    }
  };

  const dataToPass = {
    data: data,
    goals: selectedGoals,
  };

  console.log(data);

  const goalsData = [
    {
      id: 1,
      icon: goalImg,
      title: "Get new clients",
    },
    {
      id: 2,
      icon: goalImg,
      title: "Save time doing intake",
    },
    {
      id: 3,
      icon: goalImg,
      title: "Simplify online bookings",
    },
    {
      id: 4,
      icon: goalImg,
      title: "Connect with clients virtually",
    },
  ];

  const handleContinue = () => {
    // Implement your logic, e.g., form validation, navigation, etc.
    console.log("Continue clicked.");
    navigate("/grow/recommendations", { state: { dataToPass } });
  };

  return (
    <div>
      <SignupToolbar onlyHelp={true} />
      <div className="goals-container">
        {/* Main content area */}
        <div className="goals-content">
          {/* Heading + subtext */}
          <h2 className="goals-title">How can Quidpro help your practice?</h2>
          <p className="goals-subtext">
            Select all that apply. Your selections will help us recommend the
            right Quidpro products for your needs.
          </p>

          {/* Cards row */}
          <div className="cards-container">
            {goalsData.map((goal) => (
              <div
                key={goal.id}
                className="goal-card"
                onClick={() => handleToggle(goal.id)}
              >
                <img src={goal.icon} alt={goal.title} className="goal-icon" />
                <h3 className="goal-title">{goal.title}</h3>
                <p className="goal-text">{goal.text}</p>
                <div className="checkbox-container">
                  <input
                    type="checkbox"
                    checked={selectedGoals.includes(goal.id)}
                    onChange={() => handleToggle(goal.id)}
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom navigation bar */}
        <DeterminateProgress value={80} />
        <div className="bottom-bar">
          <div className="bottom-bar-left">
            <span className="section-label">Your goals</span>
            <span className="step-indicator">Step 4 of 5</span>
          </div>
          <button
            type="button"
            className="continue-btn-login"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
